import React from 'react'
import { css } from '@emotion/react'
import qs from 'query-string'

import errorpageGraphic from '../images/errorpage-graphic.jpg'
import errorpageGraphic2x from '../images/errorpage-graphic@2x.jpg'
import { getTaskworldFrontendUrl } from '../services/Env'
import Colors from '../theme/Colors'
import GlobalStyles from '../theme/GlobalStyles'
import Link from './Link'
import Text from './Text'

interface IAppError extends Error {
  status?: number
}

function getUserFriendlyErrorMessage(error: IAppError) {
  switch (error.message) {
    case 'JsonWebTokenError: jwt must be provided':
      return 'Session expired. Please return to your workspace and log in again.'

    case 'User does not have sufficient permissions to view this':
      return 'Workspace ID is missing or does not exist. Check your URL!'

    default:
      return error.message
  }
}

export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { errorMessage: string | null; errorCode: number | null }
> {
  constructor(props: any) {
    super(props)

    this.state = {
      errorMessage: null,
      errorCode: null,
    }
  }

  static getDerivedStateFromError(error: IAppError) {
    return {
      errorMessage: getUserFriendlyErrorMessage(error),
      errorCode: error.status,
    }
  }

  render() {
    if (this.state.errorMessage) {
      const workspaceName = sessionStorage.getItem('workspaceName') || ''
      const { planName, planPeriod } = qs.parse(location.search)
      return (
        <React.Fragment>
          <GlobalStyles />

          <div
            css={css`
              background-color: ${Colors.White};
            `}
          >
            <div
              css={css`
                text-align: center;
                padding: 30px;
              `}
            >
              <div>
                <img
                  css={css`
                    height: 270px;
                    @media (max-width: 768px) {
                      width: 200px;
                      height: 200px;
                    }
                  `}
                  src={errorpageGraphic}
                  srcSet={`${errorpageGraphic} 1x, ${errorpageGraphic2x} 2x`}
                  alt="Payment failed"
                />

                <h1>Something went wrong.</h1>

                <div
                  css={css`
                    margin-bottom: 2rem;
                  `}
                >
                  {this.state.errorMessage}
                </div>

                {getTaskworldFrontendUrl() &&
                  (this.state.errorCode === 401 ? (
                    <Link
                      color="teal"
                      to={{
                        path: getTaskworldFrontendUrl() + '/' + workspaceName,
                        hash: '#/workspace/workspace-plan',
                        query: {
                          redirectTo: window.location.pathname,
                          planName: String(planName),
                          planPeriod: String(planPeriod),
                        },
                      }}
                    >
                      <Text bold>Refresh session</Text>
                    </Link>
                  ) : (
                    <Link color="teal" to={getTaskworldFrontendUrl() + '/' + workspaceName}>
                      <Text bold>Return to workspace</Text>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }

    return this.props.children
  }
}
